import { Caption } from '@liveauctioneers/hammer-ui-core/text';

import { ItemCardPriceRow } from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRow';
import ItemCardMenu from '@/components/ItemCard/components/Menu/ItemCardMenu';
import { useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import {
    getItemSummaryBidCount,
    getItemSummaryIsPassed,
    getItemSummaryIsPaused,
    getItemSummaryIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type CardPriceProps = {
    cardHovered: boolean;
    enterLinkHoverState: () => void;
    isMobile: boolean;
    isPending: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
    linkHovered: boolean;
};

export const CardPrice = ({
    cardHovered,
    enterLinkHoverState,
    isMobile,
    isPending,
    itemId,
    leaveLinkHoverState,
    linkHovered,
}: CardPriceProps) => {
    const formatMessage = useAppFormatMessage();
    const bidCount = useAppSelector((state) => getItemSummaryBidCount(state, itemId));
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isPaused = useAppSelector((state) => getItemSummaryIsPaused(state, itemId));
    const isLoggedIn = useAppSelector(isUserLoggedIn);

    return (
        <section
            className="flex justify-between [grid-area:currentbidprice]"
            data-testid="myItemsCardPrice"
        >
            <section className="flex items-center">
                <ItemCardPriceRow
                    isHovered={linkHovered}
                    itemId={itemId}
                    onMouseEnter={enterLinkHoverState}
                    onMouseLeave={leaveLinkHoverState}
                />
                {!isSold && !isPassed && !isPaused && !isPending && bidCount > 0 && (
                    <Caption
                        className="ml-2xs"
                        color="secondary"
                    >
                        {formatMessage(['itemBidding', 'bid'], { values: { bidCount } })}
                    </Caption>
                )}
            </section>
            {isLoggedIn && !isMobile && (
                <ItemCardMenu
                    itemId={itemId}
                    showIcon={cardHovered}
                />
            )}
        </section>
    );
};
